import { Stack, Typography } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { useTranslation } from 'react-i18next';

import { Color, Level } from 'theme/enums';

interface IProps {
  sx?: SxProps;
}

export const CorporatePartNotSetUp = ({ sx = {} }: IProps) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ alignItems: 'flex-start', justifyContent: 'center', py: 1, ...sx }}>
      <Typography color={Color.NEUTRAL} level={Level.TITLE_SM} sx={{ fontStyle: 'italic' }}>
        {t('messagePartNotSetUp')}
      </Typography>
    </Stack>
  );
};
